/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/forward-15-rec";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Forward15Rec";
export { I as Forward15Rec };
